import { api } from '@/shared/redux/api/_generated/api/billing-api.generated';

export const billingApi = api.enhanceEndpoints({
  addTagTypes: ['TenantSubscription'],
  endpoints: {
    ReadTenantSubscriptionStatus: {
      providesTags: [{ type: 'TenantSubscription', id: 'SUBSCRIPTION' }],
    },
    ReadTenantSubscription: {
      providesTags: [{ type: 'TenantSubscription', id: 'SUBSCRIPTION' }],
    },
    ReadTenantScheduledSubscriptionChanges: {
      providesTags: [{ type: 'TenantSubscription', id: 'SUBSCRIPTION' }],
    },
    SwitchTenantPlan: {
      invalidatesTags: ['TenantSubscription'],
    },
    UpdateTenantSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    RevokeSubscriptionChange: {
      invalidatesTags: ['TenantSubscription'],
    },
    CancelSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    CreateSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    HandleTermsAndConditionsAcceptedForBilling: {
      invalidatesTags: ['TenantSubscription'],
    },
    ReadTenantFeatureUsageStats: {
      keepUnusedDataFor: 0,
    },
    ReadTenantEntitlementUsageStats: {
      keepUnusedDataFor: 0,
    },
    ReadTenantSubscriptionTermUsage: {
      keepUnusedDataFor: 0,
    },
    ReadTenantFeatureUsageStatsExport: {
      keepUnusedDataFor: 0,
    },
  },
});

export const {
  useReadResalePlansQuery,
  useReadTenantSubscriptionStatusQuery,
  useReadTenantSubscriptionQuery,
  useSwitchTenantPlanMutation,
  useUpdateTenantSubscriptionMutation,
  useReadTenantScheduledSubscriptionChangesQuery,
  useRevokeSubscriptionChangeMutation,
  useCancelSubscriptionMutation,
  useCreateSubscriptionMutation,
  useReadTenantFeatureUsageStatsQuery,
  useReadTenantEntitlementUsageStatsQuery,
  useReadTenantSubscriptionTermUsageQuery,
  useHandleTermsAndConditionsAcceptedForBillingMutation,
  useLazyReadTenantFeatureUsageStatsExportQuery,
} = billingApi;
